// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=5e4d31ae-6707-4f22-ad5f-d79924bee9ec";
};